import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const AuditLogViewer = ({ language, direction }) => {
  const [filterType, setFilterType] = useState('all');
  const [filterUser, setFilterUser] = useState('all');

  const auditLogs = [
    {
      id: 1,
      timestamp: '2026-01-27T18:30:00',
      user: 'Ahmed Benali',
      action: 'user_created',
      actionEn: 'Created new user',
      actionFr: 'Nouvel utilisateur créé',
      actionAr: 'تم إنشاء مستخدم جديد',
      details: 'Created user: Fatima Zahra',
      type: 'user_management',
      severity: 'info'
    },
    {
      id: 2,
      timestamp: '2026-01-27T17:45:00',
      user: 'Ahmed Benali',
      action: 'config_changed',
      actionEn: 'Changed system configuration',
      actionFr: 'Configuration système modifiée',
      actionAr: 'تم تغيير تكوين النظام',
      details: 'Updated backup frequency to daily',
      type: 'system_config',
      severity: 'warning'
    },
    {
      id: 3,
      timestamp: '2026-01-27T16:20:00',
      user: 'Youssef Alami',
      action: 'user_login',
      actionEn: 'User logged in',
      actionFr: 'Connexion utilisateur',
      actionAr: 'تسجيل دخول المستخدم',
      details: 'Successful login from IP: 192.168.1.100',
      type: 'authentication',
      severity: 'info'
    },
    {
      id: 4,
      timestamp: '2026-01-27T15:10:00',
      user: 'Ahmed Benali',
      action: 'permission_changed',
      actionEn: 'Changed user permissions',
      actionFr: 'Autorisations utilisateur modifiées',
      actionAr: 'تم تغيير أذونات المستخدم',
      details: 'Updated permissions for Laila Mansouri',
      type: 'user_management',
      severity: 'warning'
    },
    {
      id: 5,
      timestamp: '2026-01-27T14:30:00',
      user: 'System',
      action: 'backup_completed',
      actionEn: 'Backup completed',
      actionFr: 'Sauvegarde terminée',
      actionAr: 'اكتمل النسخ الاحتياطي',
      details: 'Automatic backup completed successfully',
      type: 'system_backup',
      severity: 'success'
    },
    {
      id: 6,
      timestamp: '2026-01-27T13:15:00',
      user: 'Ahmed Benali',
      action: 'user_deleted',
      actionEn: 'Deleted user',
      actionFr: 'Utilisateur supprimé',
      actionAr: 'تم حذف المستخدم',
      details: 'Deleted inactive user: Mohamed Tazi',
      type: 'user_management',
      severity: 'error'
    },
    {
      id: 7,
      timestamp: '2026-01-27T12:00:00',
      user: 'Fatima Zahra',
      action: 'user_login',
      actionEn: 'User logged in',
      actionFr: 'Connexion utilisateur',
      actionAr: 'تسجيل دخول المستخدم',
      details: 'Successful login from IP: 192.168.1.105',
      type: 'authentication',
      severity: 'info'
    },
    {
      id: 8,
      timestamp: '2026-01-27T11:30:00',
      user: 'System',
      action: 'security_alert',
      actionEn: 'Security alert',
      actionFr: 'Alerte de sécurité',
      actionAr: 'تنبيه أمني',
      details: 'Multiple failed login attempts detected',
      type: 'security',
      severity: 'error'
    }
  ];

  const labels = {
    title: {
      en: 'Audit Log',
      fr: 'Journal d\'audit',
      ar: 'سجل التدقيق'
    },
    filterType: {
      en: 'Filter by Type',
      fr: 'Filtrer par type',
      ar: 'تصفية حسب النوع'
    },
    filterUser: {
      en: 'Filter by User',
      fr: 'Filtrer par utilisateur',
      ar: 'تصفية حسب المستخدم'
    },
    export: {
      en: 'Export Log',
      fr: 'Exporter le journal',
      ar: 'تصدير السجل'
    },
    timestamp: {
      en: 'Timestamp',
      fr: 'Horodatage',
      ar: 'الطابع الزمني'
    },
    user: {
      en: 'User',
      fr: 'Utilisateur',
      ar: 'المستخدم'
    },
    action: {
      en: 'Action',
      fr: 'Action',
      ar: 'الإجراء'
    },
    details: {
      en: 'Details',
      fr: 'Détails',
      ar: 'التفاصيل'
    }
  };

  const typeOptions = [
    { value: 'all', label: language === 'en' ? 'All Types' : language === 'fr' ? 'Tous les types' : 'جميع الأنواع' },
    { value: 'user_management', label: language === 'en' ? 'User Management' : language === 'fr' ? 'Gestion des utilisateurs' : 'إدارة المستخدمين' },
    { value: 'system_config', label: language === 'en' ? 'System Config' : language === 'fr' ? 'Configuration système' : 'تكوين النظام' },
    { value: 'authentication', label: language === 'en' ? 'Authentication' : language === 'fr' ? 'Authentification' : 'المصادقة' },
    { value: 'system_backup', label: language === 'en' ? 'System Backup' : language === 'fr' ? 'Sauvegarde système' : 'النسخ الاحتياطي للنظام' },
    { value: 'security', label: language === 'en' ? 'Security' : language === 'fr' ? 'Sécurité' : 'الأمان' }
  ];

  const userOptions = [
    { value: 'all', label: language === 'en' ? 'All Users' : language === 'fr' ? 'Tous les utilisateurs' : 'جميع المستخدمين' },
    { value: 'Ahmed Benali', label: 'Ahmed Benali' },
    { value: 'Youssef Alami', label: 'Youssef Alami' },
    { value: 'Fatima Zahra', label: 'Fatima Zahra' },
    { value: 'System', label: 'System' }
  ];

  const filteredLogs = auditLogs?.filter(log => {
    const typeMatch = filterType === 'all' || log?.type === filterType;
    const userMatch = filterUser === 'all' || log?.user === filterUser;
    return typeMatch && userMatch;
  });

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    if (language === 'ar') {
      return date?.toLocaleString('ar-MA');
    } else if (language === 'fr') {
      return date?.toLocaleString('fr-FR');
    }
    return date?.toLocaleString('en-US');
  };

  const getActionText = (log) => {
    if (language === 'fr') return log?.actionFr;
    if (language === 'ar') return log?.actionAr;
    return log?.actionEn;
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'success':
        return 'bg-success/10 text-success';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'error':
        return 'bg-error/10 text-error';
      default:
        return 'bg-primary/10 text-primary';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'success':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      default:
        return 'Info';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg" style={{ direction }}>
      <div className="px-4 md:px-6 py-4 border-b border-border">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          <h2 className="text-lg font-semibold text-foreground">{labels?.title?.[language]}</h2>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Select
              options={typeOptions}
              value={filterType}
              onChange={setFilterType}
              className="w-full sm:w-48"
            />
            <Select
              options={userOptions}
              value={filterUser}
              onChange={setFilterUser}
              className="w-full sm:w-48"
            />
            <Button
              variant="outline"
              iconName="Download"
              iconPosition="left"
              onClick={() => console.log('Export audit log')}
              fullWidth
              className="sm:w-auto"
            >
              {labels?.export?.[language]}
            </Button>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full hidden lg:table">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {labels?.timestamp?.[language]}
              </th>
              <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {labels?.user?.[language]}
              </th>
              <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {labels?.action?.[language]}
              </th>
              <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {labels?.details?.[language]}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {filteredLogs?.map((log) => (
              <tr key={log?.id} className="hover:bg-muted/50 transition-colors">
                <td className="px-4 md:px-6 py-4 whitespace-nowrap">
                  <p className="text-sm text-foreground">{formatTimestamp(log?.timestamp)}</p>
                </td>
                <td className="px-4 md:px-6 py-4 whitespace-nowrap">
                  <p className="text-sm font-medium text-foreground">{log?.user}</p>
                </td>
                <td className="px-4 md:px-6 py-4">
                  <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${getSeverityColor(log?.severity)}`}>
                    <Icon name={getSeverityIcon(log?.severity)} size={14} />
                    {getActionText(log)}
                  </span>
                </td>
                <td className="px-4 md:px-6 py-4">
                  <p className="text-sm text-muted-foreground">{log?.details}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="lg:hidden divide-y divide-border">
          {filteredLogs?.map((log) => (
            <div key={log?.id} className="p-4 hover:bg-muted/50 transition-colors">
              <div className="flex items-start justify-between mb-2">
                <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium ${getSeverityColor(log?.severity)}`}>
                  <Icon name={getSeverityIcon(log?.severity)} size={12} />
                  {getActionText(log)}
                </span>
              </div>
              <div className="space-y-1">
                <p className="text-sm font-medium text-foreground">{log?.user}</p>
                <p className="text-xs text-muted-foreground">{formatTimestamp(log?.timestamp)}</p>
                <p className="text-sm text-muted-foreground mt-2">{log?.details}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {filteredLogs?.length === 0 && (
        <div className="flex flex-col items-center justify-center py-12 px-4">
          <Icon name="FileText" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground text-center">
            {language === 'en' ? 'No audit logs found' : language === 'fr' ? 'Aucun journal d\'audit trouvé' : 'لم يتم العثور على سجلات تدقيق'}
          </p>
        </div>
      )}
    </div>
  );
};

export default AuditLogViewer;